module.exports = __webpack_public_path__ + "static/media/bulk_upload_transit_returns.6577217d.csv";